export default function LoadingSuspense() {
    return (
      <div className="loading">
        <span className="pulse"></span>
      </div>
    );
}  